<template>
    <div>
        <b-message>
            Leaderboard for game: <b>{{gameName}}</b>
        </b-message>
        <button class="button is-light btn-margin" @click.prevent="cancel()">Back to games list</button>

        <button class="button is-success btn-margin" @click.prevent="downloadLeaderboardToPdf()">
            Download Summary
        </button>
        <button v-if="!hasPreparedPictures" @click="prepareZip" class="button btn-margin is-primary"
                :class="{ 'is-loading' : isPreparingZip }">
            Zip games pictures
        </button>
        <a v-else :href="url" download="game" class="button is-success btn-margin ">Download games pictures</a>

        <div id='leaderboard'>
            <leaderboard-table
                    :isBase64ImageRequired="true"
                    :game-name="gameName"
            ></leaderboard-table>
        </div>
        <b-message>Photos for <b>{{gameName}}</b></b-message>

        <section class="container" v-if="!isLoading">
            <gallery :images="photos" :index="index" @close="index = null"></gallery>

            <div
                    class="gallery_image"
                    v-for="(photo, imageIndex) in photos"
                    :key="imageIndex"
                    @click="index = imageIndex"
                    :style="{ backgroundImage: 'url(' + photo + ')', backgroundSize: '300px 300px', height: '200px', width: '200px', margin: '10px' }"
            ></div>
        </section>
        <div style="display: block; float: none; padding-top:250px">&nbsp;</div>
    </div>
</template>

<script>
    import LeaderboardTable from './single/LeaderboardTable'
    import teamsService from '../services/teamsService'
    import VueGallery from 'vue-gallery'
    import jsPdf from 'jspdf'
    import html2canvas from 'html2canvas'
    import downloadService from '../services/download-pictures.service'
    import displayHelper from '../helpers/display-helper'

    export default {
        name: 'game-summary',
        components: {
            LeaderboardTable,
            'gallery': VueGallery
        },
        data() {
            return {
                gameId: this.$route.params.id,
                gameName: this.$route.params.name,
                isLoading: true,
                photos: [],
                index: null,
                hasPreparedPictures: false,
                url: '',
                isPreparingZip: false,
            }
        },
        async created() {
            try {
                if (this.$route.params.id) {
                    this.gameId = this.$route.params.id
                    this.photos = await teamsService.getTeamPhotos(this.gameId)
                } else {
                    displayHelper.displayError(this, 'This game could not be found. Please try again')
                    console.log('not found')
                }
            } catch (err) {
                displayHelper.displayError(this, 'Oops, there was an error: ' + err)
                console.log('error' + err)
            } finally {
                this.isLoading = false
            }
        },
        methods: {
            downloadLeaderboardToPdf() {
                html2canvas.logging = true
                const fileName = this.gameName + '.pdf'
                const title = this.gameName
                var parent = this
                html2canvas(document.getElementById('leaderboard'))
                    .then(function (canvas) {
                        const leaderBoardCanvas = canvas.toDataURL('image/jpeg,1.0')
                        const imgWidth = (canvas.width * 18) / 240
                        const imgHeight = (canvas.height * 18) / 240
                        const pdfFile = new jsPdf('p', 'mm', 'a4')
                        pdfFile.setFontSize(20)
                        pdfFile.text(60, 20, title)
                        pdfFile.addImage(leaderBoardCanvas, 'JPEG', 15, 40, imgWidth, imgHeight)
                        pdfFile.save(fileName)

                        displayHelper.displaySuccess(parent, 'Game summary downloaded successfully!')
                    })
            },
            cancel() {
                this.$router.go(-1)
            },
            prepareZip() {
              this.isPreparingZip = true
              var parent = this
              downloadService.prepareZip(this.gameId)
                  .then((url) => {
                    this.url = url
                    this.hasPreparedPictures = true
                  })
                  .catch((err) => {
                    console.log(err)
                    displayHelper.displayError(parent, 'No images found or a generic error happened.')
                  })
                  .finally(() => {
                    this.isPreparingZip = false
                    })
            }
        }
    }
</script>

<style lang="scss" type="text/scss" scoped>

    .photos {
        background-color: #fafafa;
    }

    .gallery_image {
        float: left;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center center;
        border: 1px solid #ebebeb;
        margin: 5px;
    }

    .photos_frame {
        padding: 20px;
    }

    .btn-margin {
        margin-left: 5px;
        margin-right: 5px;
        margin-bottom: 30px;
    }

</style>
